import React, { useState, useEffect } from "react";
import { IBubble } from "../../Interfaces/IBubbles";
import { useParams } from "react-router-dom";

import axiosInstance from "../../Services/AxiosAPICaller";
import BubbleDetail from "../../Components/BubbleDetail/BubbleDetail";
import Carousel from "../../Components/Carousel/Carousel";
import ContactGroupGetter from "../../Components/ContactGroupGetter/ContactGroupGetter";
import LinkGroupGetter from "../../Components/LinkGroupGetter/LinkGroupGetter";
import "../../Styles/App.css";

function OpenedBubblePage() {
  const { Id } = useParams<{ Id: string }>();
  const [bubble, setBubble] = useState<IBubble | null>(null);

  useEffect(() => {
    axiosInstance
      .get<{ data: { id: number; attributes: any } }>(
        `/bulles/${Id}?populate[groupes_de_contacts][fields][0]=id&populate[groupe_de_liens][fields][0]=id&populate[groupes_d_images][fields][0]=id`
      )
      .then((response) => {
        const item = response.data.data;
        const ResponseBubble: IBubble = {
          Id: item.id,
          Title: item.attributes.Titre,
          Position: item.attributes.position,
          Description: item.attributes.Description,
          UsefullLinks: item.attributes.liens_utiles,
          IsProtectedByMail: item.attributes.Authentification_Mail,
          ImagesGroup: item.attributes.groupes_d_images.data[0]
            ? item.attributes.groupes_d_images.data[0].id
            : null,
          ContactsGroup: item.attributes.groupes_de_contacts.data || null,
          LinksGroup: item.attributes.groupe_de_liens.data || null,
        };
        setBubble(ResponseBubble);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération de la bulle:", error);
      });
  }, [Id]);

  return (
    <>
      <BubbleDetail bubble={bubble} />
      {bubble && bubble.ImagesGroup > 0 && <Carousel Id={bubble.ImagesGroup} />}
      {bubble && bubble.ContactsGroup.length > 0 && (
        <ContactGroupGetter BulleId={bubble.Id} />
      )}
      {bubble && bubble.LinksGroup.length > 0 && (
        <LinkGroupGetter BulleId={bubble.Id} />
      )}
    </>
  );
}

export default OpenedBubblePage;
